import React, { memo, useState } from 'react';
import { Button, Carousel, Col, Row, Spin } from 'antd';
import "./grid-view.css"
import ImgIcon from '../../../../view/img-icon';
import { useEnquiry } from '../../enquiry.hook';
import { EnquiryGridDetail } from './enquiry-grid-details.component';
import { EnquiryRes } from '../../../../response/enquiry.response';

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const EnquiryGridViewComponent: React.FC = memo(() => {

    const { enquiryGroupList, loading, updateLoading, fetchEnquiryList, enquirySearchReq } = useEnquiry()

    let carouselRef: any = null;
    const contentStyle: React.CSSProperties = {
        margin: 0,
        height: '160px',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#364d79',
    };

    const prevArrow = <button className="carousel-arrow">Previous</button>;
    const nextArrow = <button className="carousel-arrow">Next</button>;

    const [activeIndex, setActiveIndex] = useState(0)

    const clearFilter = async () => {
        updateLoading(true)
        await fetchEnquiryList({
            ...enquirySearchReq,
            statusList: [] as string[],
            assigneeIdList: [],
            pageNumber: 1
        }, () => { updateLoading(false) }, () => { updateLoading(false) })
    }

    const getGridView = React.useMemo(() => {
        window.scrollTo(0, 0);
        return enquiryGroupList.map((enquiryList: EnquiryRes[], index: number) => {
            return <Col id={`vertical_col_grid_${index}`} md={12} lg={6} xl={6} style={{
                marginRight: 20,
                minWidth: 332,
                maxWidth: 364,
                marginTop: 20
            }}>
                <EnquiryGridDetail enquiryList={enquiryList} />
            </Col>
        })
    }, [enquiryGroupList])

    const getMobileGridView = React.useMemo(() => {
        window.scrollTo(0, 0);
        return enquiryGroupList.length > 0 ? <div style={contentStyle}>
            <EnquiryGridDetail enquiryList={[...enquiryGroupList[activeIndex]]} />
        </div> : <></>
    }, [enquiryGroupList, activeIndex])

    return (
        <React.Fragment>
            {!isMobile &&
                <Row style={{
                    overflow: 'auto',
                    flexFlow: 'nowrap'
                }}

                    className='d-web-grid'
                >
                    {(enquiryGroupList.length > 0 && !loading) ? getGridView : loading ? <Spin style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '24vh' }} /> :
                        <div style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '24vh', width: 'fit-content' }} >
                            <p>No Data Found</p>
                            <Button onClick={clearFilter} type='primary'>Clear Filter</Button>
                        </div>}

                </Row>
            }

            {isMobile && <div className='m-web-slider' style={{
                marginBottom: 100
            }}>

                <div style={{ maxWidth: 364, margin: 'auto' }}>
                    {enquiryGroupList.length > 0 ? getMobileGridView
                        : loading ? <Spin style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '24vh' }} /> :
                            <div style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '24vh', width: 'fit-content' }} >
                                <p>No Data Found</p>
                                <Button onClick={clearFilter} type='primary'>Clear Filter</Button>
                            </div>}
                </div>

                {enquiryGroupList.length > 0 &&
                    <>
                        <Button className='slider-arrow left' onClick={() => {
                            setActiveIndex(prevIndex => {
                                // setTimeout(() => {
                                    // window.scrollTo(0, 0);
                                // }, 1000)
                                return (prevIndex === 0) ?
                                    enquiryGroupList.length - 1 :
                                    prevIndex - 1
                            })
                        }}>
                            <ImgIcon iconName="left-arrow.svg" iconWidth="16px" />
                        </Button>
                        <Button className='slider-arrow right' onClick={() => {
                            setActiveIndex(prevIndex => {
                                return (prevIndex === enquiryGroupList.length - 1) ?
                                    0 :
                                    prevIndex + 1
                            })
                        }}>
                            <ImgIcon iconName="right-arrow.svg" iconWidth="16px" />
                        </Button>
                    </>
                }
            </div>}


        </React.Fragment>
    )
})